/*
 * @Description  : 专题页模板配置接口
 * @Author       : wuxuebing
 * @Date         : 2025-02-25 14:04:52
 * @LastEditors  : wuxuebing
 * @LastEditTime : 2025-03-28 09:04:20
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\templateConfiguration.js
 */


import request from '../request.js'

// 专题页模板配置-分页 --- 朱新宇
export const getAllTag = function (data) {
    return request({
        url: '/userTenantCenter/getPageTems',
        method: 'post',
        data
    })
}

// 专题页模板配置-保存/修改 --- 朱新宇
export const savePageTem = function (data) {
    return request({
        url: '/userTenantCenter/savePageTem',
        method: 'post',
        data
    })
}
//本地
// export const getUserTenantPage = function (data) {
//     return request({
//         url: '/topicTem/getUserTenantPage',
//         method: 'post',
//         data
//     })
// }
//测试环境
export const getUserTenantPage = function (data) {
    return request({
        url: '/userTenantCenter/getUserTenantPage',
        method: 'post',
        data
    })
}

//平台投标服务费（包年）-分页  --- 朱新宇
export const selectServiceFeePage = function (data) {
    return request({
        url: '/userTenantCenter/selectServiceFeePage',
        method: 'post',
        data
    })
}
//平台投标服务费（包年）-查看  --- 朱新宇
export const getServiceFeeDetail = function (data) {
    return request({
        url: '/userTenantCenter/getServiceFeeDetail',
        method: 'post',
        data
    })
}

//平台投标服务费（包年）-配置  --- 朱新宇
export const saveServiceFee = function (data) {
    return request({
        url: '/userTenantCenter/saveServiceFee',
        method: 'post',
        data
    })
}

//权益查询   --- 朱新宇
export const selectServiceFeeRights = function (data) {
    return request({
        url: '/userTenantCenter/selectServiceFeeRights',
        method: 'post',
        data
    })
}

// 手动关闭包年服务   --- 朱新宇
export const closeService = function (data) {
    return request({
        url: '/userTenantCenter/closeService',
        method: 'post',
        data
    })
}